import React, { useState } from "react";
import axios from "axios";
import html2pdf from "html2pdf.js";
import "./Report.css";

const ReportPage = () => {

  const [email, setEmail] = useState("");
  const [report, setReport] = useState(null);
  const [showInput, setShowInput] = useState(true);

  const handleDownloadPDF = async () => {

  //  STEP 1: Track download (backend ku send)
  try {
    await axios.post("/track-download", {
      email: report.email,
      name: report.name,
      reportId: report.reportId,
      action: "download",
      time: new Date()
    });
  } catch (err) {
    console.log("Tracking failed");
  }

  //  STEP 2: PDF download (same as before)
  const element = document.querySelector(".report");

  const opt = {
    margin: 0,
    filename: `${report.name}_Report.pdf`,
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      scale: 2,
      scrollY: 0
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait"
    },
    pagebreak: {
      mode: ['css', 'legacy']
    }
  };

  html2pdf().set(opt).from(element).save();
};
  const handleGetReport = async () => {
    try {
      const res = await axios.get(`/get-report?email=${email}`);
      setReport(res.data);
      setShowInput(false);
      
    await axios.post("/track-download", {
      email: res.data.email,
      name: res.data.name,
      reportId: res.data.reportId,
      action: "view"
    });
    } catch (err) {
      alert("Error fetching report");
    }
  };

  return (
    <div className="page">

        {/* 🔥 INTRO */}
  {showInput && (
    <>
      <div className="reportIntro">
        <h1>Performance Assessment Report</h1>
        <p>
          Get your complete visual performance analysis including reaction speed,
          memory, anticipation, and more.
        </p>
      </div>

      <div className="inputBox">
        <input
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button onClick={handleGetReport}>Get Report</button>
      </div>
    </>
  )}
  
      {/* REPORT */}
      {report && (
      <div className="downloadWrapper">
        <button
          className="downloadBtn"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </button>
      </div>
    )}
      {report && (
        
        <div className="report">

          {/* HEADER */}
          <div className="headerRow">
            <div className="logo">
              <img src="/Logo.png" alt="Forge Your Peak" className="brand-logo" />
            </div>

            <div className="company">
              <h2>Forge Your Peak  Pvt Ltd</h2>
              <p>Assessment Report</p>
            </div>

            <div className="contact">
              <p>support@forgeyourpeak.in</p>
              <p>+91 8056023798</p>
              <p>https://forgeyourpeak.in/</p>
            </div>
          </div>

          {/* INFO TABLE */}
          <table className="infoTable">
            <tbody>
              <tr>
                <td>Name: {report.name}</td>
                <td>Athlete Id: {report.athleteId}</td>
              </tr>

              <tr>
                <td>Email: {report.email}</td>
                <td>Report Id: {report.reportId}</td>
              </tr>

              <tr>
                <td>Test Type: {report.testType}</td>
                <td>Collection Date: {report.collectionDate}</td>
              </tr>
            </tbody>
          </table>

          {/* MAIN TABLE */}
          <table className="mainTable">

            <thead>
              <tr>
                <th>Metric</th>
                <th>Sub-Metric</th>
                <th>Value</th>
                <th>Percentile</th>
              </tr>
            </thead>

            <tbody>

              {/* BASIC */}
              {(() => {
                const rows = [
                  report.metrics.visualAcuity && {
                    label: "Visual Acuity",
                    value: report.metrics.visualAcuity.value,
                    percentile: report.metrics.visualAcuity.percentile
                  },
                   // 🔥 ADD THIS
                  report.metrics.contrastSensitivity && {
                    label: "Contrast Sensitivity",
                    value: report.metrics.contrastSensitivity.value,
                    percentile: report.metrics.contrastSensitivity.percentile
                  }
                ].filter(Boolean);

                if (rows.length === 0) return null;

                return rows.map((row, i) => (
                  <tr key={row.label}>
                    {i === 0 && (
                      <td className="orange" rowSpan={rows.length}>
                        Basic Visual Functions
                      </td>
                    )}
                    <td>{row.label}</td>
                    <td>{row.value}</td>
                    <td>{row.percentile || "-"}</td>
                  </tr>
                ));
              })()}

              {/* PROCESSING */}
              {(() => {
                const rows = [
                  report.metrics.simpleReaction && {
                    label: "Simple Reaction Speed",
                    value: report.metrics.simpleReaction.value,
                    percentile: report.metrics.simpleReaction.percentile
                  },
                  report.metrics.complexReaction && {
                    label: "Complex Reaction Speed",
                    value: report.metrics.complexReaction.value,
                    percentile: report.metrics.complexReaction.percentile
                  }
                ].filter(Boolean);

                if (rows.length === 0) return null;

                return rows.map((row, i) => (
                  <tr key={row.label}>
                    {i === 0 && (
                      <td className="blue" rowSpan={rows.length}>
                        Visual Processing Speed
                      </td>
                    )}
                    <td>{row.label}</td>
                    <td>{row.value}</td>
                    <td>{row.percentile || "-"}</td>
                  </tr>
                ));
              })()}

              {/* EXECUTIVE */}
              {(() => {
                const rows = [
                  report.metrics.handEyeCoordination && {
                    label: "Hand-Eye Coordination",
                    value: report.metrics.handEyeCoordination.value,
                    percentile: report.metrics.handEyeCoordination.percentile
                  },
                  report.metrics.handEyeResponseTime && {
                    label: "Hand-Eye Response Time",
                    value: report.metrics.handEyeResponseTime.value,
                    percentile: report.metrics.handEyeResponseTime.percentile
                  },
                  report.metrics.shortTermMemory && {
                    label: "Short Term Memory",
                    value: report.metrics.shortTermMemory.value,
                    percentile: report.metrics.shortTermMemory.percentile
                  },
                  report.metrics.memoryLevel && {
                    label: "Working Memory",
                    value: report.metrics.memoryLevel.value,
                    percentile: report.metrics.memoryLevel.percentile
                  },
                  report.metrics.anticipationScore && {
                    label: "Anticipation",
                    value: report.metrics.anticipationScore.value,
                    percentile: report.metrics.anticipationScore.percentile
                  },
                  report.metrics.searchSpan && {
                    label: "Search Span",
                    value: report.metrics.searchSpan.value,
                    percentile: report.metrics.searchSpan.percentile
                  }
                ].filter(Boolean);

                if (rows.length === 0) return null;

                return rows.map((row, i) => (
                  <tr key={row.label}>
                    {i === 0 && (
                      <td className="green" rowSpan={rows.length}>
                        Visual Executive Functions
                      </td>
                    )}
                    <td>{row.label}</td>
                    <td>{row.value}</td>
                    <td>{row.percentile || "-"}</td>
                  </tr>
                ));
              })()}

            </tbody>
          </table>

          {/* PYRAMID */}
          <div className="pyramidSection">

            <h3>Testing Pyramid</h3>

            <div className="pyramidWrap">

              <div className="pyramid">
                <div className="layer top">Visual Executive Functions</div>
                <div className="layer middle">Visual Processing Speed</div>
                <div className="layer bottom">Basic Visual Functions</div>
              </div>

              <div className="desc">

                <div className="descItem greenLine">
                  <h4>Visual Executive Functions</h4>
                  <p>Attention, working memory, anticipation</p>
                </div>

                <div className="descItem blueLine">
                  <h4>Visual Processing Speed</h4>
                  <p>Reaction speed</p>
                </div>

                <div className="descItem orangeLine">
                  <h4>Basic Visual Functions</h4>
                  <p>Clarity & contrast</p>
                </div>

              </div>

            </div>

          </div>
          <div className="page-break"></div>

          <div className="secondPage">
          <div className="pdfTopSpace"></div>

            <h2 className="title">Test Definitions & Details</h2>

            <table className="bigTable">

              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Sub-Metric</th>
                  <th>Definition and Details</th>
                </tr>
              </thead>

              <tbody>

                {/* 🟠 BASIC */}
                <tr>
                  <td className="orangeMain" rowSpan="2">
                    Basic<br/>Visual<br/>Functions
                  </td>

                  <td className="orangeSub">
                    Binocular Visual Acuity
                  </td>

                  <td>
                    <b>What it measures:</b> How clearly one can see small details at 6 m (both eyes)..<br/>
                    <b>How to read:</b> The higher the better (6/6 = 1.0; 6/4.5 ≈ 1.33).<br/>
                    <b>Why it matters:</b> Sharp visual clarity supports faster reactions, accurate targeting, and precise execution under pressure. It’s the foundation for reading the game early, coordinating efficiently
                  </td>
                </tr>
                <tr>
                  <td className="orangeSub">
                    Contrast Sensitivity
                  </td>

                  <td>
                    <b>What it measures:</b> Ability to detect objects against low contrast backgrounds.<br/>
                    <b>How to read:</b> Lower value indicates better sensitivity (can detect finer contrast differences).<br/>
                    <b>Why it matters:</b> Critical in low light, fog, or fast-moving environments where clear visibility is reduced. Helps in early detection of objects, opponents, and movement.
                  </td>
                </tr>

                

                {/* 🔵 PROCESSING */}
                {report.metrics.simpleReaction && (
                  <tr>
                    <td className="blueMain" rowSpan="2">
                      Visual<br/>Processing<br/>Speed
                    </td>

                    <td className="blueSub">Simple Reaction Speed</td>

                    <td>
                       <b>What it measures:</b> Time taken to respond to a sudden light cue.<br/>
                      <b>How to read:</b> Reported in milliseconds. Lower score implies quicker reactions.<br/>
                      <b>Why it matters:</b> Supports paying attention to cues, timely starts, and fewer slip-ups.
                    </td>
                  </tr>
                )}

                {report.metrics.complexReaction && (
                  <tr>
                    <td className="blueSub">Complex Reaction Speed</td>
                    <td>
                      <b>What it measures:</b> How quickly an athlete reacts to unpredictable or multi-choice stimuli.<br/>
                      <b>How to read:</b> Reported in milliseconds. Lower score implies quicker reactions.<br/>
                      <b>Why it matters:</b> Reflects processing speed, focus, and adaptability under pressure. Essential in fast-paced sports where milliseconds decide performance.
                    </td>
                  </tr>
                )}

                {/* 🟢 EXECUTIVE */}
                
               {(() => {

                const executiveRows = [
                  report.metrics.handEyeCoordination && {
                    label: "Hand-Eye Coordination",
                    content: (
                      <>
                        <b>What it measures:</b> How accurately both hands work together under visual guidance.<br/>
                        <b>How to read:</b> percentage accuracy. Higher = steadier control and better timing<br/>
                        <b>Why it matters:</b> Essential for precise motor actions like catching, hitting, tracking objects, and maintaining accuracy under dynamic conditions.
                      </>
                    )
                  },
                  report.metrics.handEyeResponseTime && {
                    label: "Hand-Eye Response Time",
                    content: (
                      <>
                        <b>What it measures:</b> How quickly a person responds to visual stimuli using hand movement.<br/>
                        <b>How to read:</b> Reported in milliseconds. Lower score implies quicker responses.<br/>
                        <b>Why it matters:</b> Reflects visual-motor response speed and the ability to respond quickly to visual cues.
                      </>
                    )
                  },
                  report.metrics.shortTermMemory && {
                    label: "Short-Term Visual Memory",
                    content: (
                      <>
                        <b>What it measures:</b> How well one remembers numbers and recite them back in the order.<br/>
                        <b>How to read:</b> Longest number string said correctly. Higher implies stronger short-term memory.<br/>
                        <b>Why it matters:</b> Supports strategy recall, quick calculations, and multi-step execution
                      </>
                    )
                  },

                  report.metrics.memoryLevel && {
                    label: "Working Memory",
                    content: (
                      <>
                        <b>What it measures:</b> How well one remembers numbers and recite them back in the order.<br/>
                        <b>How to read:</b> Longest number string said correctly. Higher implies stronger short-term memory.<br/>
                        <b>Why it matters:</b> Supports strategy recall, quick calculations, and multi-step execution
                      </>
                    )
                  },

                  report.metrics.anticipationScore && {
                    label: "Anticipation",
                    content: (
                      <>
                        <b>What it measures:</b> Anticipation of motion.<br/>
                        <b>How to read:</b> Percent correct, higher implies better prediction and timing.<br/>
                        <b>Why it matters:</b> Crucial for reading motion and reacting early, from catching and intercepting to crossing, passing, or positioning accurately in dynamic environments.
                      </>
                    )
                  },

                  report.metrics.searchSpan && {
                    label: "Search Span",
                    content: (
                      <>
                        <b>What it measures:</b> How fast one can find the right items when the clock is ticking.<br/>
                        <b>How to read:</b> More correct finds implies better search-and-find ability.<br/>
                        <b>Why it matters:</b> Key for reading the game, spotting opportunities, and reacting fast.
                      </>
                    )
                  }

                ].filter(Boolean);

                return executiveRows.map((row, index) => (
                  <tr key={row.label}>

                    {index === 0 && (
                      <td className="greenMain" rowSpan={executiveRows.length}>
                        Visual<br/>Executive<br/>Functions
                      </td>
                    )}

                    <td className="greenSub">{row.label}</td>

                    <td>{row.content}</td>

                  </tr>
                ));

              })()}

              </tbody>

            </table>

          </div>

        </div>
      )}

    </div>
  );
};

export default ReportPage;